module.exports = __webpack_public_path__ + "static/media/safety-test-and-certificate.a79d7073.svg";